import React,{useEffect} from 'react'
import AOS from 'aos'
import 'aos/dist/aos.css'

export default function Herosec() {
    useEffect(()=>{
        AOS.init({duration:1000})
    },[])
  return (
    <section className="hero-section page-section scroll-to-page" id="home">
        <div className="custom-container">
            <div className="hero-content content-width">
                <div className="section-header">
                    <h4 className="subtitle scroll-animation" data-animation="fade_from_bottom" data-aos='fade-up'>
                        <i className="las la-home"></i> Introduction
                    </h4>
                    <h1 className="scroll-animation" data-aos='fade-up'>I am <span>Tryhard</span>, Software Developer</h1>
                </div>
 
                <div className="facts d-flex">
                    <div className="right scroll-animation" data-aos='fade-left'>
                        <h1>1000+</h1>
                        <p>plugin copies sold</p>
                    </div>
                </div>
            </div>
        </div>
    </section>
  )
}
